import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Attachment, AttachmentControllerService } from '../../core/generated';
import { MaterialModule } from '../material/material.module';
import { DeviceDetectorService } from 'ngx-device-detector';

interface Document {
    id: string;
    name: string;
    type: string;
    size: number;
    uploadDate: Date;
}

@Component({
    selector: 'app-document-list-dialog',
    standalone: true,
    imports: [MaterialModule],
    templateUrl: './document-list-dialog.component.html',
    styleUrls: ['./document-list-dialog.component.scss']
})
export class DocumentListDialogComponent implements OnInit {

    deviceService = inject(DeviceDetectorService);
    attachments: Attachment[] = [];
    loading = true;
    error = false;
    isMobile = this.deviceService.isMobile();

    constructor(
        private dialogRef: MatDialogRef<DocumentListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { ownerDocumentsCpfCnpj: string, grantedCompanyCnpj: string },
        private attachmentsService: AttachmentControllerService
    ) { }

    ngOnInit(): void {
        this.loadDocuments();
    }

    loadDocuments(): void {
        this.loading = true;
        this.attachmentsService.getFilesListSharedByOwner(this.data.ownerDocumentsCpfCnpj, this.data.grantedCompanyCnpj)
            .subscribe({
                next: (attachments: Attachment[]) => {
                    this.attachments = attachments;
                    this.loading = false;
                }
            });
    }

    download(fileName: string | undefined) {
        if (fileName) {
            this.attachmentsService.downloadFile(fileName).subscribe((file) => {
                // Create a URL for the blob directly
                const url = URL.createObjectURL(file);

                // Create an anchor element and trigger download
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            });
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
